var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-industries-tags"},_vm._l((_setup.industries),function(industry){return _c(_setup.IndustryTag,{key:industry.externalId,on:{"delete":function($event){return _setup.removeIndustry(industry.externalId)}}},[_vm._v(" "+_vm._s(industry.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }